import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowHeadDown = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { transform: "translate(12.500000, 12.000000) rotate(-270.000000) translate(-12.500000, -12.000000) ", points: "10 17 15 12 10 7" })));
};
export default ArrowHeadDown;
